import { createNS } from "./util";

const NAMESPACE = "ERRORS/TRANSACTION";
const ns = createNS(NAMESPACE);

export const NON_CUSTOMER_EMAIL = ns("NON_CUSTOMER_EMAIL");
